import { ConfigStore } from '@sureinc/atlas-common/config';

import { env } from '@/config/env.config';

const DEVTOOLS_ENVIRONMENTS = new Set(['dev', 'qa']);

export function setEnvironment() {
  ConfigStore.config.endpoints.ATLAS_BACKEND = env.VITE_BACKEND_URL;
  ConfigStore.config.environment = env.VITE_ENVIRONMENT;
}

export function isDevtoolsEnvironment(environment: string): boolean {
  return DEVTOOLS_ENVIRONMENTS.has(environment);
}

export function isUpperEnvironment(environment: string): boolean {
  return environment === 'production' || environment === 'uat';
}

export const isUpperEnvironments = isUpperEnvironment(env.VITE_ENVIRONMENT);
